import type { FC, PropsWithChildren } from "react";

import * as s from "./SideBySide.module.scss";

type Props = PropsWithChildren<{
	onClick?: () => void;
}>;

const SideBySide: FC<Props> = ({ onClick, children }) => (
	<div
		onClick={onClick}
		role="link"
		tabIndex={0}
		onKeyUp={onClick}
		className={s.sideBySide}
	>
		{children}
	</div>
);

export default SideBySide;
